import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect } from "@/mixins/index";
import { addnoticUser, returnnoticUserList, updatanoticUserList } from "@/api/dataAll/noticUser";
export default {
  name: "addNoticUser",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  mixins: [serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      titleName: "",
      searchData: {
        id: '',
        email_list: '',
        special_product_id: ""
      },
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProductLabel'),
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: this.$t('game'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('platformNotEmpty'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('channelNotEmpty'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pkgNotEmpty'),
          trigger: "blur"
        }],
        email_list: [{
          required: true,
          message: this.$t('pleaseUseEnglishComma'),
          trigger: "change"
        }] // parameter: [{ required: true, message: "参数", trigger: "blur" }],

      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, _yield$returnnoticUse, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!row) {
                  _context.next = 8;
                  break;
                }

                datas = {
                  game_id: _this.rawData.game_id,
                  id: row.id
                };
                _context.next = 5;
                return returnnoticUserList(datas);

              case 5:
                _yield$returnnoticUse = _context.sent;
                data = _yield$returnnoticUse.data;
                _this.searchData = _objectSpread(_objectSpread(_objectSpread({}, _this.searchData), data), {}, {
                  special_product_id: row.product_id
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData(true);
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this2.searchData.kind = 1;
          _this2.searchData.game_id = '';
          var reqFn = _this2.searchData.id ? updatanoticUserList : addnoticUser;
          reqFn(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(res.message);

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            } else {
              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData(type) {
      this.$refs.form.resetFields();
      this.searchData = {
        id: type ? '' : this.searchData.id,
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id,
        email_list: ''
      };
    }
  }
};